<template>
    <div v-if="hasAuth('Admin')">
        <list-container :header="translate('settings.titles')" v-show="!$route.params.id">
            <template v-slot:commands>
                <excel-exporter table-id="titleExport" :columns="columns" url="/title/get" modelName="Title" orderBy="Name"></excel-exporter>
                <button class="btn btn-primary" @click="$router.push({ name:'TitleDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('newTitle')}}
                </button>
            </template>
            <list :columns="columns" url="/title/get" modelName="Title"  orderBy="IsActive desc,Name">
            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import Vue from 'vue'
import ExcelExporter from '../components/ExcelExporter.vue';

export default {
    data(){
        return {
            columns : [
                {
                    Key: "Name",
                    Title: this.translate('externalSigner.name'),
                    SortField: "Name"
                },
                {
                    Key: "IsActive",
                    Title: this.translate('targetSystemImport.active'),
                    SortField: "IsActive",
                    Class: "text-center",
                    Content(i) {
                        return Vue.filter('checkicon')(i.IsActive);
                    }
                }
            ]
        }
    },
    components: {
        list,ExcelExporter,
        listContainer
    },
    created(){
        console.log("Kültür");
        this.searchDetsisByName("Kültür")
    },
    methods: {
        // select(i){
        //     console.log('Kayıt seçildi: ', i);
        //     this.$router.push('draft/' + i.Id);
        // }
    }
}
</script>